import Api from '@/services/api';
import {removeEmptyParams} from '@utils';

export default {
  ticketCategorys(filter) {
    return Api()
      .get('/ticketcategorys', {params: removeEmptyParams(filter)})
      .then((res) => {
        res.data.forEach((e) => {
          this.formatRes(e);
        });
        return res.data;
      });
  },
  ticketCategoriesForCreation(filter) {
    return Api()
      .get('/ticketcategorys/forcreation', {params: removeEmptyParams(filter)})
      .then((res) => {
        res.data.forEach((e) => {
          this.formatRes(e);
        });
        return res.data;
      });
  },
  ticketCategory(id) {
    return Api()
      .get('/ticketcategory/' + id)
      .then((res) => this.formatRes(res.data));
  },
  create(ticketCategory) {
    return Api()
      .post('/ticketcategory', ticketCategory)
      .then((res) => this.formatRes(res.data));
  },
  update(ticketCategory) {
    return Api()
      .put('/ticketcategory/' + ticketCategory.id, ticketCategory)
      .then((res) => this.formatRes(res.data));
  },
  delete(ticketCategory) {
    return Api()
      .delete('/ticketcategory/' + ticketCategory.id)
      .then(() => ticketCategory);
  },
  formatRes(e) {
    return e;
  },
};
